import _ from "lodash";
let CACHED_CONFIG;
export const getRuntimeConfig = async () => {
  if (_.isNil(CACHED_CONFIG)) {
    const runtimeConfig = await fetch("/runtimeConfig.json");
    CACHED_CONFIG = runtimeConfig.json();
  }
  return Promise.resolve(CACHED_CONFIG);
};
